$(function () {
  if ($(".countdown-container").length > 0) {
    $(".countdown-container").each(function (index, el) {
      var timer = function () {
        "use strict";

        var date1 = new Date().getTime();
        var date2 = new Date(
          $(el).find(".end-date").val() + "+02:00"
        ).getTime();

        var diff = date2 - date1;

        var days = diff / (1000 * 60 * 60 * 24);
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / 3.6e6);
        var minutes = Math.floor((diff % 3.6e6) / 6e4) + 1;
        var seconds = Math.floor((diff % 6e4) / 1000) + 1;

        if (diff < 0) {
          days = 0;
          hours = 0;
          minutes = 0;
          seconds = 0;
          clearInterval(timer);
        }

        $(el).find(".days h2").html(Math.floor(days));
        $(el).find(".hours h2").html(Math.floor(hours));
        $(el).find(".minutes h2").html(Math.floor(minutes));
        $(el).find(".seconds h2").html(Math.floor(seconds));
      };
      setInterval(timer, 1000);
    });
  }
});
